import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-progresso',
  templateUrl: './progresso.component.html',
  styleUrls: ['./progresso.component.css']
})
export class ProgressoComponent implements OnInit {

  @Input() situacao: string;
  @Input() posicaoAtual: number;
  @Input() totalRegistro: number;

  bg: string = 'bg-primary';
  constructor() { }

  ngOnInit() {
  }

  get porcento(): string {
    return `${(this.posicaoAtual * 100) / this.totalRegistro}%`;
  }

}
